import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';
import getConfig from '../../../helpers/config';
import {
  PaginationProps,
  PaginationReturn,
} from '../../../interfaces/pagination';
import {
  ProgramStatus,
  ProgramTematik,
} from '../../../interfaces/program-tematik';
import { getPrepareHeaders } from '../get-prepare-headers';

const { test } = getConfig();

export interface ProgramTematikParams extends PaginationProps {
  emertimi?: string;
  statusProgramiTematik?: ProgramStatus;
}

export const programeTematikeApi = createApi({
  reducerPath: 'programeTematikeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['ProgrameTematike', 'ProgramTematik'],
  endpoints: builder => ({
    getProgrameTematike: builder.query<
      PaginationReturn<ProgramTematik>,
      ProgramTematikParams
    >({
      query: args => getCommonUrl(args, '/program-tematik'),
      providesTags: ['ProgrameTematike'],
    }),

    createProgramTematik: builder.mutation<void, Partial<ProgramTematik>>({
      query: ({ id, ...body }) => ({
        url: id ? `/program-tematik/${id}` : '/program-tematik',
        method: id ? 'PATCH' : 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) =>
        id
          ? ['ProgrameTematike', { type: 'ProgramTematik', id }]
          : ['ProgrameTematike'],
    }),

    deleteProgramTematik: builder.mutation<void, number>({
      query: id => ({
        url: `/program-tematik/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ProgrameTematike'],
    }),
  }),
});

export const {
  useGetProgrameTematikeQuery,
  useLazyGetProgrameTematikeQuery,
  useCreateProgramTematikMutation,
  useDeleteProgramTematikMutation,
} = programeTematikeApi;
